import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

interface PillProps {
    hasValue: boolean;
    isOpen: boolean;
}

export const Pill = styled.div<PillProps>`
    display: inline-flex;
    align-items: center;
    border: 1px ${(props) => (props.hasValue ? 'solid' : 'dashed')} ${theme.colors.border.default};
    border-radius: 24px;
    height: 24px;
    padding: 0 ${(props) => (props.hasValue ? '3' : '7')}px 0 3px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    background-color: ${(props) => (props.isOpen ? theme.colors.background.subtle : theme.colors.background.default)};
    transition: background-color 75ms ease;

    &:hover {
        background-color: ${theme.colors.background.subtle};
    }
`;
